import { RouteType } from '@/main/menu/constants';

import { Doklad } from './doklad';
import { MontazDV } from './montazDV';
import { Ozakazka } from './ozakazka';
import { Zakazka } from './zakazka';
import { RezervaceND } from './rezervaceND';
import { ZakazkaArchiv } from './zakazkaArchiv';
import { PaketovyModul } from './paketovyModul';
import { CheckIn } from './checkIn';
import { CasovaUdalost } from './casovaUdalost';
import { NAME as name } from './constants';
import { PartReturnRequest } from './zakazka/PartReturnRequest';
import { ReverseJobOrder } from './zakazka/ReverseJobOrder';
import { ServiceJob } from './serviceJob';

export const menu = {
	name,
	orderAlphabetically: false,
	list: [
		{ name: 'Zakazka', route: Zakazka.name },
		{ name: 'ServiceJob', route: ServiceJob.name },
		{ name: 'CheckIn', route: CheckIn.name },
		{ name: 'Ozakazka', route: Ozakazka.name },
		{ name: 'Servis_RezervaceND', route: RezervaceND.name },
		{ name: 'PaketovyModul', route: PaketovyModul.name },
		{ name: 'MONTAZDV', route: MontazDV.name },
		{ name: 'ARCHIV_DOKLADU', route: Doklad.name },
		{ name: 'ARCHIV_ZAKAZEK', route: ZakazkaArchiv.name },
		{ name: CasovaUdalost.constants.SNIMANIE_CASU, route: CasovaUdalost.constants.SNIMANIE_CASU, routeType: RouteType.name },
		{ name: 'UpravyCasu', route: CasovaUdalost.name },
		{ name: 'PART_RETURN', route: PartReturnRequest.name },
		{ name: 'REVERSE_JOB_ORDER', route: ReverseJobOrder.name },
		
	],
};
